import types from "./types";

const InitialState = {
  isFetchingList: false,
  programs: [],
  programsListError: "",

  isFetchingActualProgramsList: false,
  actualPrograms: [],
  actualProgramsListError: "",

  isFetchingActualGroupList: false,
  actualGroups: [],
  actualGroupListError: "",

  isFetchingProgram: false,
  programCard: null,
  programCardError: "",

  isFetchingFullProgram: false,
  programFullInfo: null,
  programFullError: "",

  programHtmlDescription: null,
  programHtmlDescrError: "",

  programHtmlAnounce: null,
  programHtmlAnounceError: "",

  isFetchingModule: false,
  moduleCard: null,
  moduleCardError: "",

  isFetchingFullModule: false,
  moduleFullInfo: null,
  moduleFullError: "",

  isUpdatingProgram: false,
  updatedProgram: null,
  updateProgramError: "",

  isCreatingProgram: false,
  createdProgram: null,
  createProgramError: "",

  isUpdatingLogo: false,
  updatedLogo: null,
  logoUpdateError: "",

  isUpdatingProgramFile: false,
  updatedProgramFile: null,
  fileUpdateError: "",

  isUpdatingCertificate: false,
  updatedCertificate: null,
  certUpdateError: "",

  isDeletingProgram: false,
  deletedProgram: null,
  programDeleteError: "",

  isDeletingLogo: false,
  deletedLogo: null,
  logoDeleteError: "",

  isDeletingProgramFile: false,
  deletedProgramFile: null,
  fileDeleteError: "",

  isDeletingCertificate: false,
  deletedCertificate: null,
  certDeleteError: "",

  isFetchingOrganizations: false,
  organizations: [],
  orgListError: "",

  isFetchingEduForms: false,
  eduForms: [],
  eduFormsError: "",

  isFetchingTargetGroups: false,
  targetGroups: [],
  targetGroupsError: "",

//module purpose
  isFetchingPurpose: false,
  purpose: null,
  purposeError: "",
};

export default (
  state = InitialState,
  action
) => {
  switch (action.type) {
    case types.GET_PROGRAMS_REQUEST:
      return {
        ...state,
        isFetchingList: action.isFetchingList
      };
    case types.GET_PROGRAMS_COMPLETED:
      return {
        ...state,
        isFetchingList: action.isFetchingList,
        programs: action.programs
      };
    case types.GET_PROGRAMS_ERROR:
      return {
        ...state,
        isFetchingList: action.isFetchingList,
        programsError: action.programsError
      };

    case types.GET_ACTUAL_PROGRAMS_REQUEST:
      return {
        ...state,
        isFetchingActualProgramsList: action.isFetchingActualProgramsList
      };
    case types.GET_ACTUAL_PROGRAMS_COMPLETED:
      return {
        ...state,
        isFetchingActualProgramsList: action.isFetchingActualProgramsList,
        actualPrograms: action.actualPrograms
      };
    case types.GET_ACTUAL_PROGRAMS_ERROR:
      return {
        ...state,
        isFetchingActualProgramsList: action.isFetchingActualProgramsList,
        actualProgramsError: action.actualProgramsError
      };

    case types.GET_ACTUAL_PROGRAM_GROUPS_REQUEST:
      return {
        ...state,
        isFetchingActualGroupList: action.isFetchingActualGroupList
      };
    case types.GET_ACTUAL_PROGRAM_GROUPS_COMPLETED:
      return {
        ...state,
        isFetchingActualGroupList: action.isFetchingActualGroupList,
        actualGroups: action.actualGroups
      };
    case types.GET_ACTUAL_PROGRAM_GROUPS_ERROR:
      return {
        ...state,
        isFetchingActualGroupList: action.isFetchingActualGroupList,
        actualGroupsError: action.actualGroupsError
      };

    case types.GET_PROGRAM_REQUEST:
      return {
        ...state,
        isFetchingProgram: action.isFetchingProgram
      };
    case types.GET_PROGRAM_COMPLETED:
      return {
        ...state,
        isFetchingProgram: action.isFetchingProgram,
        programCard: action.programCard
      };
    case types.GET_PROGRAM_ERROR:
      return {
        ...state,
        isFetchingProgram: action.isFetchingProgram,
        programCardError: action.programCardError
      };
    case types.GET_FULL_PROGRAM_REQUEST:
      return {
        ...state,
        programFullInfo: null,
        isFetchingFullProgram: action.isFetchingFullProgram
      };
    case types.GET_FULL_PROGRAM_COMPLETED:
      return {
        ...state,
        isFetchingFullProgram: action.isFetchingFullProgram,
        programFullInfo: action.programFullInfo
      };
    case types.GET_FULL_PROGRAM_ERROR:
      return {
        ...state,
        isFetchingFullProgram: action.isFetchingFullProgram,
        programFullError: action.programFullError
      };

    case types.GET_PROGRAM_ANOUNCE_REQUEST:
      return {
        ...state,
      };

    case types.GET_PROGRAM_ANOUNCE_COMPLETED:
      return {
        ...state,
        programHtmlAnounce: action.programHtmlAnounce,
      };

    case types.GET_PROGRAM_ANOUNCE_ERROR:
      return {
        ...state,
        programHtmlAnounceError: action.programHtmlAnounceError,
      };

    case types.GET_PROGRAM_DESCRIPTION_REQUEST:
      return {
        ...state,
      };

    case types.GET_PROGRAM_DESCRIPTION_COMPLETED:
      return {
        ...state,
        programHtmlDescription: action.programHtmlDescription,
      };

    case types.GET_PROGRAM_DESCRIPTION_ERROR:
      return {
        ...state,
        programHtmlDescrError: action.programHtmlDescrError,
      };

      case types.GET_MODULE_REQUEST:
        return {
          ...state,
          isFetchingModule: action.isFetchingModule
        };
      case types.GET_MODULE_COMPLETED:
        return {
          ...state,
          isFetchingModule: action.isFetchingModule,
          moduleCard: action.moduleCard
        };
      case types.GET_MODULE_ERROR:
        return {
          ...state,
          isFetchingModule: action.isFetchingModule,
          moduleCardError: action.moduleCardError
        };
      case types.GET_FULL_MODULE_REQUEST:
        return {
          ...state,
          isFetchingFullModule: action.isFetchingFullModule
        };
      case types.GET_FULL_MODULE_COMPLETED:
        return {
          ...state,
          isFetchingFullModule: action.isFetchingFullModule,
          moduleFullInfo: action.moduleFullInfo
        };
      case types.GET_FULL_MODULE_ERROR:
        return {
          ...state,
          isFetchingFullModule: action.isFetchingFullModule,
          moduleFullError: action.moduleFullError
        };

        case types.GET_MODULE_PURPOSE_REQUEST:
          return {
            ...state,
            isFetchingPurpose: action.isFetchingPurpose
          };
        case types.GET_MODULE_PURPOSE_COMPLETED:
          return {
            ...state,
            isFetchingPurpose: action.isFetchingPurpose,
            purpose: action.purpose
          };
        case types.GET_MODULE_PURPOSE_ERROR:
          return {
            ...state,
            isFetchingPurpose: action.isFetchingPurpose,
            purposeError: action.purposeError
          };

    case types.GET_ORG_LIST_REQUEST:
      return {
        ...state,
        isFetchingOrganizations: action.isFetchingOrganizations
      };
    case types.GET_ORG_LIST_COMPLETED:
      return {
        ...state,
        isFetchingOrganizations: action.isFetchingOrganizations,
        organizations: action.organizations
      };
    case types.GET_ORG_LIST_ERROR:
      return {
        ...state,
        isFetchingOrganizations: action.isFetchingOrganizations,
        orgListError: action.orgListError
      };

    case types.ADD_NEW_PROGRAM_INFORMATION_REQUEST:
      return {
        ...state,
        isCreatingProgram: action.isCreatingProgram
      };
    case types.ADD_NEW_PROGRAM_INFORMATION_COMPLETED:
      return {
        ...state,
        isCreatingProgram: action.isCreatingProgram,
        createdProgram: action.createdProgram
      };
    case types.ADD_NEW_PROGRAM_INFORMATION_ERROR:
      return {
        ...state,
        isCreatingProgram: action.isCreatingProgram,
        createProgramError: action.createProgramError
      };

    case types.UPDATE_PROGRAM_INFORMATION_REQUEST:
      return {
        ...state,
        isUpdatingProgram: action.isUpdatingProgram
      };
    case types.UPDATE_PROGRAM_INFORMATION_COMPLETED:
      return {
        ...state,
        isUpdatingProgram: action.isUpdatingProgram,
        updatedProgram: action.updatedProgram
      };
    case types.UPDATE_PROGRAM_INFORMATION_ERROR:
      return {
        ...state,
        isUpdatingProgram: action.isUpdatingProgram,
        updateProgramError: action.updateProgramError
      };

    case types.UPDATE_PROGRAM_LOGO_REQUEST:
      return {
        ...state,
        isUpdatingLogo: action.isUpdatingLogo
      };
    case types.UPDATE_PROGRAM_LOGO_COMPLETED:
      return {
        ...state,
        isUpdatingLogo: action.isUpdatingLogo,
        updatedLogo: action.updatedLogo
      };
    case types.UPDATE_PROGRAM_LOGO_ERROR:
      return {
        ...state,
        isUpdatingLogo: action.isUpdatingLogo,
        logoUpdateError: action.logoUpdateError
      };

    case types.UPDATE_PROGRAM_FILE_REQUEST:
      return {
        ...state,
        isUpdatingProgramFile: action.isUpdatingProgramFile
      };
    case types.UPDATE_PROGRAM_FILE_COMPLETED:
      return {
        ...state,
        isUpdatingProgramFile: action.isUpdatingProgramFile,
        updatedProgramFile: action.updatedProgramFile
      };
    case types.UPDATE_PROGRAM_FILE_ERROR:
      return {
        ...state,
        isUpdatingProgramFile: action.isUpdatingProgramFile,
        fileUpdateError: action.fileUpdateError
      };

    case types.UPDATE_CERTIFICATE_FILE_REQUEST:
      return {
        ...state,
        isUpdatingCertificate: action.isUpdatingCertificate,
        updatedCertificate: null
      };
    case types.UPDATE_CERTIFICATE_FILE_COMPLETED:
      return {
        ...state,
        isUpdatingCertificate: action.isUpdatingCertificate,
        updatedCertificate: action.updatedCertificate
      };
    case types.UPDATE_CERTIFICATE_FILE_ERROR:
      return {
        ...state,
        isUpdatingCertificate: action.isUpdatingCertificate,
        certUpdateError: action.certUpdateError
      };

    case types.DELETE_PROGRAM_LOGO_REQUEST:
      return {
        ...state,
        isDeletingLogo: action.isDeletingLogo
      };
    case types.DELETE_PROGRAM_LOGO_COMPLETED:
      return {
        ...state,
        isDeletingLogo: action.isDeletingLogo,
        deletedLogo: action.deletedLogo
      };
    case types.DELETE_PROGRAM_LOGO_ERROR:
      return {
        ...state,
        isDeletingLogo: action.isDeletingLogo,
        logoDeleteError: action.logoDeleteError
      };

    case types.DELETE_PROGRAM_FILE_REQUEST:
      return {
        ...state,
        isDeletingProgramFile: action.isDeletingProgramFile
      };
    case types.DELETE_PROGRAM_FILE_COMPLETED:
      return {
        ...state,
        isDeletingProgramFile: action.isDeletingProgramFile,
        deletedProgramFile: action.deletedProgramFile
      };
    case types.DELETE_PROGRAM_FILE_ERROR:
      return {
        ...state,
        isDeletingProgramFile: action.isDeletingProgramFile,
        fileDeleteError: action.fileDeleteError
      };

    case types.DELETE_CERTIFICATE_FILE_REQUEST:
      return {
        ...state,
        isDeletingCertificate: action.isDeletingCertificate,
        deletedCertificate: null
      };
    case types.DELETE_CERTIFICATE_FILE_COMPLETED:
      return {
        ...state,
        isDeletingCertificate: action.isDeletingCertificate,
        deletedCertificate: action.deletedCertificate
      };
    case types.DELETE_CERTIFICATE_FILE_ERROR:
      return {
        ...state,
        isDeletingCertificate: action.isDeletingCertificate,
        certDeleteError: action.certDeleteError
      };

    case types.GET_EDU_FORM_LIST_REQUEST:
      return {
        ...state,
        isFetchingEduForms: action.isFetchingEduForms
      };
    case types.GET_EDU_FORM_LIST_COMPLETED:
      return {
        ...state,
        isFetchingEduForms: action.isFetchingEduForms,
        eduForms: action.eduForms
      };
    case types.GET_EDU_FORM_LIST_ERROR:
      return {
        ...state,
        isFetchingEduForms: action.isFetchingEduForms,
        eduFormsError: action.eduFormsError
      };

    case types.GET_TARGET_GROUP_LIST_REQUEST:
      return {
        ...state,
        isFetchingTargetGroups: action.isFetchingTargetGroups
      };
    case types.GET_TARGET_GROUP_LIST_COMPLETED:
      return {
        ...state,
        isFetchingTargetGroups: action.isFetchingTargetGroups,
        targetGroups: action.targetGroups
      };
    case types.GET_TARGET_GROUP_LIST_ERROR:
      return {
        ...state,
        isFetchingTargetGroups: action.isFetchingTargetGroups,
        targetGroupsError: action.targetGroupsError
      };

    case types.DELETE_PROGRAM_REQUEST:
      return {
        ...state,
        isDeletingProgram: action.isDeletingProgram
      };
    case types.DELETE_PROGRAM_COMPLETED:
      return {
        ...state,
        isDeletingProgram: action.isDeletingProgram,
        deletedProgram: action.deletedProgram
      };
    case types.DELETE_PROGRAM_ERROR:
      return {
        ...state,
        isDeletingProgram: action.isDeletingProgram,
        programDeleteError: action.programDeleteError
      };

    default:
      return state;
  }
};
